import { render, staticRenderFns } from "./FirmenDublettenEintrag.vue?vue&type=template&id=649cb145"
import script from "./FirmenDublettenEintrag.vue?vue&type=script&lang=js"
export * from "./FirmenDublettenEintrag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports